import React from "react";
import FlexLayout from "../../controls/FlexLayout";
import { DNDContainer } from "../DNDContainer";
/**
 * Content pane component.
 * For Classic layout.
 */
export const ContentPane = ({ children }) => {
    return (React.createElement(FlexLayout.Flex, { fill: true, id: "main-window-pane" },
        React.createElement(DNDContainer, { style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
            } }, children)));
};
